/**
 * Back in Stock Notification System
 * Handles email subscriptions for out-of-stock products
 */

const NotifyMe = {
  /**
   * Opens the notification modal for a product
   * @param {string} productId - Shopify product ID
   * @param {string} productTitle - Product title
   * @param {string} productImage - Product image URL
   * @param {string|null} variantId - Optional variant ID
   */
  open: function(productId, productTitle, productImage, variantId = null) {
    const modal = document.createElement('div');
    modal.id = 'notify-me-modal';
    modal.className = 'notify-me-modal';
    modal.innerHTML = `
      <div class="notify-me-modal__overlay" onclick="NotifyMe.close()"></div>
      <div class="notify-me-modal__content">
        <button class="notify-me-modal__close" onclick="NotifyMe.close()" aria-label="Close">&times;</button>
        <div class="notify-me-modal__header">
          <img src="${productImage}" alt="${productTitle}" class="notify-me-modal__image">
          <h3>${productTitle}</h3>
        </div>
        <div class="notify-me-modal__body">
          <p>Enter your email to be notified when this product is back in stock:</p>
          <form id="notify-me-form" onsubmit="NotifyMe.submit(event, '${productId}', ${variantId ? `'${variantId}'` : 'null'})">
            <input
              type="email"
              name="email"
              id="notify-email"
              placeholder="your@email.com"
              required
              autocomplete="email"
              class="notify-me-modal__input"
            >
            <div class="notify-me-modal__error" id="notify-error"></div>
            <button type="submit" class="notify-me-modal__submit">Notify Me</button>
          </form>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    // Focus email input
    setTimeout(() => {
      const emailInput = document.getElementById('notify-email');
      if (emailInput) emailInput.focus();
    }, 100);

    // Close on escape key
    document.addEventListener('keydown', NotifyMe.handleEscape);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  },

  /**
   * Closes the notification modal
   */
  close: function() {
    const modal = document.getElementById('notify-me-modal');
    if (modal) {
      modal.remove();
      document.removeEventListener('keydown', NotifyMe.handleEscape);
      document.body.style.overflow = '';
    }
  },

  /**
   * Handles escape key press to close modal
   * @param {KeyboardEvent} e - Keyboard event
   */
  handleEscape: function(e) {
    if (e.key === 'Escape') {
      NotifyMe.close();
    }
  },

  /**
   * Submits the notification subscription form
   * @param {Event} event - Form submit event
   * @param {string} productId - Shopify product ID
   * @param {string|null} variantId - Optional variant ID
   */
  submit: async function(event, productId, variantId = null) {
    event.preventDefault();

    const form = event.target;
    const email = form.email.value.trim();
    const submitButton = form.querySelector('button[type="submit"]');
    const errorDiv = document.getElementById('notify-error');

    // Validate email
    if (!NotifyMe.validateEmail(email)) {
      errorDiv.textContent = 'Please enter a valid email address.';
      return;
    }

    // Clear errors
    errorDiv.textContent = '';

    // Disable button
    submitButton.disabled = true;
    submitButton.textContent = 'Subscribing...';

    try {
      // Use Shopify Contact Form API
      const formData = new FormData();
      formData.append('contact[email]', email);
      formData.append('contact[name]', email);
      formData.append('contact[body]', `Back in stock notification request for product ID: ${productId}${variantId ? `, variant ID: ${variantId}` : ''}`);
      formData.append('form_type', 'contact');

      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      // Shopify contact form returns 303 redirect on success
      if (response.ok || response.status === 303) {
        // Success - show confirmation
        form.innerHTML = `
          <div class="notify-me-modal__success">
            <svg class="notify-me-modal__success-icon" viewBox="0 0 24 24">
              <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
            </svg>
            <p>Great! We'll notify you when this product is back in stock.</p>
          </div>
        `;

        // Track event (optional - for analytics)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'back_in_stock_subscribe', {
            'event_category': 'engagement',
            'event_label': productId
          });
        }

        if (typeof fbq !== 'undefined') {
          fbq('track', 'Subscribe', {
            value: 0,
            currency: 'USD',
            predicted_ltv: 0
          });
        }

        // Auto-close after 3 seconds
        setTimeout(NotifyMe.close, 3000);
      } else {
        throw new Error('Subscription failed. Please try again.');
      }

    } catch (error) {
      console.error('Subscription error:', error);
      errorDiv.textContent = error.message || 'Something went wrong. Please try again.';
      submitButton.disabled = false;
      submitButton.textContent = 'Notify Me';
    }
  },

  /**
   * Validates email format
   * @param {string} email - Email address to validate
   * @returns {boolean} True if valid email format
   */
  validateEmail: function(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
};

// Make globally accessible
window.NotifyMe = NotifyMe;
